import { useState, useEffect } from 'react';

function IsAzAccount() {
  const [subdomain, setSubdomain] = useState('');

  useEffect(() => {
    const { hostname } = window.location;
    const parts = hostname.split('.');

    if (parts.length > 2 || (parts.length === 2 && parts[0] !== 'localhost')) {
      setSubdomain(parts[0]);
    }
  }, []);

  return subdomain === 'az';
}

export default IsAzAccount;
